<template src="./callout-comment.html"></template>

<script lang="ts">
import commentMixin from './CommentMixin.vue'
import formatName from 'filters/format-name'
import tileMixin from 'layouts/masonry/TileMixin.vue'


export default {
  mixins: [commentMixin, tileMixin],
  methods: {
    formatUserName(user) {
      return formatName(user)
    }
  }
}
</script>

<style lang="scss" src="./callout-comment.scss"></style>
